import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthShell } from "@/components/auth/AuthShell";
import styles from "@/components/auth/AuthForm.module.scss";
import { getAuthErrorMessage } from "@/components/auth/auth-helpers";
import { useAppAuth } from "@/components/auth/AuthProvider";

export function SignInPage() {
  const { isLoaded, signIn } = useAppAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCredentialsSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!isLoaded) return;

    setIsSubmitting(true);
    setError("");
    setNotice("");

    try {
      await signIn(email, password);
      window.location.assign("/app");
    } catch (submitError) {
      setError(getAuthErrorMessage(submitError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthShell mode="login">
      <div className={styles.stack}>
        {notice ? <p className={styles.notice}>{notice}</p> : null}
        {error ? <p className={styles.error}>{error}</p> : null}

          <form className={styles.form} onSubmit={handleCredentialsSubmit}>
            <label className={styles.field}>
              <span className={styles.label}>Email</span>
              <input
                className={styles.input}
                type="email"
                autoComplete="email"
                inputMode="email"
                placeholder="you@example.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled={!isLoaded || isSubmitting}
                required
              />
            </label>

            <div className={styles.linkRow}>
              <Link className={styles.link} to="/forgot-password">
                Forgot password?
              </Link>
            </div>

            <label className={styles.field}>
              <span className={styles.label}>Password</span>
              <input
                className={styles.input}
                type="password"
                autoComplete="current-password"
                placeholder="Your password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={!isLoaded || isSubmitting}
                required
              />
            </label>

            <button className={styles.submit} type="submit" disabled={!isLoaded || isSubmitting}>
              {isSubmitting ? (
                <span className={styles.spinner}>
                  <Loader2 size={20} className={styles.spinIcon} />
                </span>
              ) : (
                "Sign in"
              )}
            </button>
          </form>

        <div className={styles.linkRow}>
          <span>New here?</span>
          <Link className={styles.link} to="/signup">
            Create account
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
